import React from 'react';

const ImageBanner = () => {
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <img 
        src="./7.jpeg" 
        alt="Banner" 
        style={{ 
          width: '100%', 
          height: 'auto',
          maxWidth: '100%',
          display: 'block'
        }} 
      />
    </div>
  );
};

export default ImageBanner;